// @flow
import { select, all, call, fork, put, takeEvery } from 'redux-saga/effects';

import {
    urlSaved,
    urlLoaded,
    urlDeleted,
    urlRequestFailed,
    urlSavedAndQuit,
    appRedirect,
    appMessageThrow,
} from '../actions';
import {fetchJSON} from "../../helpers/api";

/**
 * Watch load url request
 * @returns {IterableIterator<ForkEffect>}
 */
export function* watchUrlLoad(): any {
    yield takeEvery('URL_LOAD', function*({ payload: { domain_id, id } }) {
        try {
            const options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            };

            const response = yield call(fetchJSON, '/domains/'+domain_id+'/urls/'+id, options);
            yield put(urlLoaded(response));
        } catch (error) {
            console.warn(error);
            if (error.status_code === 404) {
                yield put(appRedirect('/error-404'));
            } else {
                yield put(appRedirect('/error-500'));
            }
        }
    });
}

/**
 * Watch user want to save a url
 * @returns {IterableIterator<ForkEffect>}
 */
export function* watchUrlSave(): any {
    yield takeEvery('URL_SAVE', function*({ payload: { domain_id, quit } }) {
        try {
            const state = yield select();

            const options = {
                body: JSON.stringify({translation: state.Url.url.translation}),
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            };

            let url = '/domains/'+domain_id+'/urls/'+state.Url.url.id;
            if (state.Url.url.revisions.length !== 0) {
                options.method = 'PUT';
                url+= '/'+state.Url.url.revisions[0].id;
            }

            const response = yield call(fetchJSON, url, options);
            if (quit) {
              yield put(urlSavedAndQuit(response));
            } else {
              yield put(urlSaved(response));
            }
        } catch (error) {
            console.warn(error);
            if (error.status_code === 404) {
                yield put(appRedirect('/error-404'));
            } else if (error.status_code === 422 || error.status_code === 409) {
                yield put(appMessageThrow(error.message, 'warning'));
                yield put(urlRequestFailed());
            } else {
                yield put(appRedirect('/error-500'));
            }
        }
    });
}

/**
 * Watch user want to save a url
 * @returns {IterableIterator<ForkEffect>}
 */
export function* watchUrlDelete(): any {
    yield takeEvery('URL_DELETE', function*({ payload: { domain_id, id } }) {
        try {
            const state = yield select();

            const options = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            };

            let url = '/domains/'+domain_id+'/urls/'+state.Url.url.id + '/'+state.Url.url.revisions[0].id;

            yield call(fetchJSON, url, options);
            yield put(urlDeleted(id));
        } catch (error) {
            console.warn(error);
            if (error.status_code === 404) {
                yield put(appRedirect('/error-404'));
            } else if (error.status_code === 422 || error.status_code === 409) {
                yield put(appMessageThrow(error.message, 'warning'));
                yield put(urlRequestFailed());
            } else {
                yield put(appRedirect('/error-500'));
            }
        }
    });
}

function* UrlSaga(): any {
    yield all([fork(watchUrlSave), fork(watchUrlLoad), fork(watchUrlDelete)]);
}

export default UrlSaga;
